import { faBuildingColumns } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CuentaBancariaFlujoTesoreriaReadingFiltersDtoProps } from "api/DTOs/CuentaBancariaFlujoTesoreriaReadingFiltersDto"

const OnRenderAccountInfo = ({
  logo,
  nombre,
}: CuentaBancariaFlujoTesoreriaReadingFiltersDtoProps) => {
  return (
    <span className='tw-flex tw-items-center tw-overflow-hidden tw-h-10'>
      {nombre ? (
        <>
          {logo ? (
            <img
              src={logo}
              alt={nombre}
              className='tw-w-14 tw-h-auto tw-object-cover tw-mr-3 tw-inline-block'
            />
          ) : (
            <FontAwesomeIcon
              icon={faBuildingColumns}
              className='tw-w-14 tw-h-7 tw-mr-3'
            />
          )}
          <span className='tw-max-w-300'>{nombre}</span>
        </>
      ) : (
        "-"
      )}
    </span>
  )
}

export default OnRenderAccountInfo
